// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__i6VNc","name":"ConsentHeader_name___3clz","birthday":"ConsentHeader_birthday__1zvYz","skeleton":"ConsentHeader_skeleton__35i23"};